import { json, type ActionFunctionArgs } from '@remix-run/node';
import { z } from 'zod';
import { updateConversationParticipants } from '~/modules/chat/api/update-conversation-participants.server';

export const ADD_PARTICIPANTS_API = '/remix-api/chat/add-participants';

const FORM_DATA_SCHEMA = z.object({
    conversationID: z.coerce.number().int().positive(),
    professionalID: z.coerce.number().int().positive().nullish(),
    memberIDs: z.array(z.coerce.number().int().positive()),
});

/**
 * API endpoint to add participants to a conversation. Use with the `useUpdateConversation` hook.
 * @see {@link packages/web/app/modules/chat/hooks/use-update-conversation.ts}
 */
export const action = async ({ context, request }: ActionFunctionArgs) => {
    const { logger } = context;
    const payload = await request.json();
    const result = FORM_DATA_SCHEMA.safeParse(payload);

    if (!result.success) {
        return json(null, { status: 400 });
    }

    try {
        const response = await updateConversationParticipants({
            context,
            conversationID: result.data.conversationID,
            professionalID: result.data.professionalID,
            addMemberIDs: result.data.memberIDs,
        });

        if (!response) {
            return json(null, { status: 500 });
        }

        return json({
            conversation: response.conversation,
            systemMessages: response.systemMessages,
        });
    } catch (error) {
        logger.error(`Error in ${ADD_PARTICIPANTS_API}`, {
            error,
            data: result.data,
        });
        return json(null, { status: 500 });
    }
};
